// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2K6z2","error":"Textarea_error__3FOHa","readonly":"Textarea_readonly__19ZfB","disabled":"Textarea_disabled__3PpsE"};